<div
  echarts
  [options]="chartOption"
  (chartInit)="onChartInit($event)"
  [style.height.px]="height"
  class="echart"
></div>
<!-- [autoResize]="true" -->
